import React from "react"

import { createPortal } from "react-dom"
import { useTranslation } from "react-i18next"
import Spinner from ".."
import { Wrapper, Title } from "./style"

export default () => {
  const { t } = useTranslation();

  return (
    createPortal(
      <Wrapper>
        <Spinner />
        <Title>{t("loading-text")}</Title>
      </Wrapper>,
      document.getElementById("spinner-root")
    )
  )
}